export default __webpack_public_path__ + "static/media/hand-shake.2a8426f4.svg";